import { fetch } from '../apiFunction';
import { BASE_URL } from '../config';
import { uploadImage } from './auth';


export const getAllUsers = async () => {
  const url = `${BASE_URL}/task/get-all-users`;
  const token = localStorage.getItem('token');
  const resp = await fetch(url, 'GET', null, token);
  return resp;
};

export const getMyProjects = async () => {
  const url = `${BASE_URL}/project/assigned-to-users`;
  const token = localStorage.getItem('token');
  const resp = await fetch(url, 'GET', null, token);
  return resp;
};

export const createTask = async (values: any) => {
  const type = 'POST';
  const url = `${BASE_URL}/task/create`;
  const token = localStorage.getItem('token');
  const payload = JSON.stringify(values);

  const resp = await fetch(url, type, payload, token);
  return resp;
};

export const archieveTask = async (taskId: string, projectId: string) => {
  const type = 'POST';
  const url = `${BASE_URL}/task/is-archieved/${taskId}`;
  const token = localStorage.getItem('token');
  const payload = JSON.stringify({
    isArchieved: true,
    projectId
  });

  const resp = await fetch(url, type, payload, token);
  return resp;
};

export const updateTask = async (values: any, taskId: any) => {
  const type = 'POST';
  const url = `${BASE_URL}/task/update/${taskId}`;
  const token = localStorage.getItem('token');
  const payload = JSON.stringify(values);
  const resp = await fetch(url, type, payload, token);
  return resp;
};

export const addComment = async (taskId: any, text: string, projectId: string) => {
  const type = 'POST';
  const url = `${BASE_URL}/comment/create`;
  const token = localStorage.getItem('token');
  const payload = JSON.stringify({ taskNo: taskId, text, projectId });
  const resp = await fetch(url, type, payload, token);
  return resp;
};

export const allCommnets = async (taskId: string, projectId: string) => {
  const type = "GET";
  const url = `${BASE_URL}/comment/get-all-comments?taskNo=${taskId}&projectId=${projectId}`;
  const token = localStorage.getItem("token");
  const resp = await fetch(url, type, null, token);
  return resp;
}

export const updateComment = async (commentId: any, values: any) => {
  const type = "POST";
  const url = `${BASE_URL}/comment/update/${commentId}`;
  const token = localStorage.getItem('token');
  const payload = JSON.stringify(values);
  const resp = await fetch(url, type, payload, token);
  return resp;
}

export const deleteComment = async (commentId: any) => {
  const type = "POST";
  const url = `${BASE_URL}/delete/${commentId}`
  const payload = null;
  const token = localStorage.getItem('token');
  const resp = await fetch(url, type, payload, token);
  return resp;
}

export const getAllTask = async (query: any) => {
  var requestQuery = '';

  if (query) {
    var requestQuery = Object.keys(query)
      .filter((v) => {
        return query[v] !== null;
      })
      .filter((v) => query[v] !== 0)
      .filter((v) => query[v] !== '')
      .map((v) => {
        return `${v}=${query[v]}`;
      })
      .join('&');
  }

  const finalRequestQuery = requestQuery;
  const type = 'GET';
  const url = `${BASE_URL}/task/get-all-task?${finalRequestQuery}`;
  const token = localStorage.getItem('token');
  const resp = await fetch(url, type, null, token);
  return resp;
};

export const changeColumn = async (taskId: string, values: any) => {
  const type = "POST";
  const url = `${BASE_URL}/task/update-status/${taskId}`
  const token = localStorage.getItem('token');
  const payload = JSON.stringify(values);
  const resp = await fetch(url, type, payload, token);
  return resp;
}

export const logTime = async (values: any) => {
  const type = "POST";
  const url = `${BASE_URL}/task/time-spent`
  const token = localStorage.getItem('token');
  const payload = JSON.stringify(values);
  const resp = await fetch(url, type, payload, token);
  return resp;
}

export const getTaskById = async (taskId: any, projectId: string) => {
  const type = 'GET';
  const url = `${BASE_URL}/task/get-task?taskNo=${taskId}&projectId=${projectId}`;
  const token = localStorage.getItem('token');
  const resp = await fetch(url, type, null, token);
  return resp;
};

export const fileRemoveHandler = async (id: any) => {
  const type = "POST";
  const url = `${BASE_URL}/issues/delete/${id}`;
  const token = localStorage.getItem('token');
  const resp = await fetch(url, type, {}, token);
  return resp;
}

export const createIssue = (data: any) => {
  const type = "POST";
  const url = `${BASE_URL}/issues/create`;
  const payload = JSON.stringify(data);
  const token = localStorage.getItem("token");
  const resp = fetch(url, type, payload, token);
  return resp;
}

export const getIssueByTaskId = async (taskId: string) => {
  const type = "GET";
  const url = `${BASE_URL}/issues/get-issues/${taskId}`;
  const token = localStorage.getItem("token");
  const resp = await fetch(url, type, null, token);
  return resp;
}

export const getUserAllIssues = async (query) => {
  var requestQuery = '';

  if (query) {
    var requestQuery = Object.keys(query)
      .filter((v) => {
        return query[v] !== null;
      })
      .filter((v) => query[v] !== 0)
      .filter((v) => query[v] !== '')
      .map((v) => {
        return `${v}=${query[v]}`;
      })
      .join('&');
  }

  const finalRequestQuery = requestQuery;

  const type = "GET";
  const url = `${BASE_URL}/task/users-task?${finalRequestQuery}`;
  const token = localStorage.getItem("token");
  const resp = await fetch(url, type, null, token);
  return resp;
}


export const getTaskFile = async (hash: string) => {
  const type = "GET";
  const url = `${BASE_URL}/user/get-file?hash=${hash}`
  const token = localStorage.getItem('token');
  const resp = await fetch(url, type, null, token);
}
